/*
	import { updatePhoneMeeting } from '@/services/BoardMeetings/PhoneMeeting/Put';

  const { phoneMeeting } = await updatePhoneMeeting ({
    json: {
			hoaID,
      phoneMeetingID,
      phoneNumber,
      
      // optional
      accessCode,

      note
    }
  });
*/

/*
  exception.fields {
    phoneNumber: [ '' ],    
  }
*/

import kms from '@/services/kms'
import { notifyError } from '@/services/notify'

export async function updatePhoneMeeting({ json }) {
  let exception = ''

  try {
    const result = await kms.put(`/BoardMeetings/PhoneMeeting`, json)

    return {
      successful: true,
      message: 'The phone meeting was updated successfully.',
      exception: null,
      phoneMeeting: result
    }
  } catch (_exception) {
    exception = _exception
  }

  let message = 'The phone meeting could not be updated.'
  notifyError(message)

  return {
    successful: false,
    message,
    exception,
    phoneMeeting: null
  }
}
